import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=51ce9e10&scoped=true&"
import script from "./type1.vue?vue&type=script&lang=js&"
export * from "./type1.vue?vue&type=script&lang=js&"
import style0 from "./type1.vue?vue&type=style&index=0&id=51ce9e10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce9e10",
  null
  
)

export default component.exports